import { useEffect, useState } from "react";
import { getPrincipalMessage } from "../Service/Api";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";

const removeHtmlTags = (str) => {
  return str.replace(/<[^>]*>/g, "");
};

const BishopDesk = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const messages = await getPrincipalMessage();
      setData(messages);
    };
    fetchData();
  }, []);

  const emptyArray = [];

  return (
    <>
      <div className="breadcrumb">
        <h2>Bishop's Desk</h2>
        <ul>
          <li>
            <Link to="/">
              {" "}
              Home <i className="fas fa-angle-right"></i>{" "}
            </Link>
          </li>
          <li>|</li>
          <li>Bishop's Desk</li>
        </ul>
      </div>
      <div className="inner_page">
        <div className="container">
          {data?.length > 0
            ? data
                ?.filter((div) => div.category === "Bishop")
                .map((item, index) => (
                  <div className="row message_inner" key={item._id || index}>
                    <div className="col-lg-4 col-md-4">
                      <LazyLoad>
                        <img
                          src={`https://webapi.entab.info/api/image/${item.attachments}`}
                          className="inner_img img-fluid"
                          alt="St Francis School, Amritsar"
                        />
                      </LazyLoad>
                    </div>
                    <div className="col-lg-8 col-md-8 messagebox">
                      <p>{removeHtmlTags(item.message)}</p>
                      <h4>{item.name} </h4>
                      <h5>
                        <strong> {item.category} </strong>
                      </h5>
                      <div className="clr"></div>
                    </div>
                  </div>
                ))
            : emptyArray.map((item, index) => (
                <div key={index} className="row">
                  <div className="row message_inner">
                    <div className="col-lg-4 col-md-4">
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SFSAP/public/Images/Bishop.png"
                          className="inner_img img-fluid"
                          alt="St Francis School, Amritsar"
                        />
                      </LazyLoad>
                    </div>
                    <div className="col-lg-8 col-md-8 messagebox">
                      <p>
                        One child, One teacher, One book. One pen can change the
                        world. Let us the little children come to me, do not
                        stop them, for it is to such as these that the kingdom
                        of God belongs.
                      </p>
                      <h4>MOST REV. JOSE SEBESTIAN T</h4>
                      <h5>
                        <strong>BISHOP</strong>
                      </h5>
                      <div className="clr"></div>
                    </div>
                  </div>
                </div>
              ))}
        </div>
      </div>
    </>
  );
};

export default BishopDesk;
